"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const constants_1 = require("../constants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.content}/v1/content/dripping`, {
    get: {
        [constants_1.DrippingEndpointKeys.GetQuizzes]: '/quizzes'
    },
    delete: {
        [constants_1.DrippingEndpointKeys.RemoveBulk]: '/bulk'
    },
    post: {
        [constants_1.DrippingEndpointKeys.PostBulk]: '/bulk'
    }
});
request_1.default.register(`${Settings_1.default.api.content}/v4/modules`, {
    get: {
        [constants_1.DrippingEndpointKeys.GetModuleClasses]: '/:moduleId/pages/classes/dripping-status',
        [constants_1.DrippingEndpointKeys.GetPageClasses]: '/:moduleId/pages/:pageId/classes/dripping-status'
    }
});
request_1.default.register(`${Settings_1.default.api.class}/v5/classes`, {
    get: {
        [constants_1.DrippingEndpointKeys.GetProductClasses]: '/'
    }
});
request_1.default.register(`${Settings_1.default.api.content}/v4/quizzes`, {
    get: {
        [constants_1.DrippingEndpointKeys.GetQuizDetails]: '/:pageId/details'
    }
});
